import { render, staticRenderFns } from "./OrderItemMenuProduct.vue?vue&type=template&id=3097a6d6&scoped=true&"
import script from "./OrderItemMenuProduct.vue?vue&type=script&lang=js&"
export * from "./OrderItemMenuProduct.vue?vue&type=script&lang=js&"
import style0 from "./OrderItemMenuProduct.vue?vue&type=style&index=0&id=3097a6d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3097a6d6",
  null
  
)

export default component.exports